export default __webpack_public_path__ + "static/media/ps_timer_screen.8ecdfab7.svg";